
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tournament/new",
      function () {
        return require("private-next-pages/tournament/new/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tournament/new"])
      });
    }
  